export default __webpack_public_path__ + "static/media/Weather.78db9dbe.jpg";